module.exports = __webpack_public_path__ + "images/external_images/img/522x277/img1.jpg";